import captureKeyboardListener from './captureKeyboardListeners';

export default function captureEscKeyListener(handler: () => void) {
  return captureKeyboardListener({ onEsc: handler });
}
